class SubscriptionInvoiceHistoryTable implements ng.IComponentController {
    invoicesList: anm.Charge[];
    isExpanded: boolean;

    constructor() {
        this.invoicesList = this.invoicesList.map(invoice => {
            const status = invoice.status === 'SUCCESS' ? 'success' : 'fail';
            const errorMessage = status === 'fail' ? invoice.status : '';
            return {
                ...invoice,
                status,
                errorMessage
            };
        });
    }
}

angular.module('animatronApp.SubscriptionInvoiceHistoryTable', [])
    .component('subscriptionInvoiceHistoryTable', {
        bindings: {
            invoicesList: '<'
        },
        controller: SubscriptionInvoiceHistoryTable,
        templateUrl: require('settings/subscription/subscription-invoice-history-table.html')
    });



// WEBPACK FOOTER //
// ./app/assets/javascripts/settings/subscription/SubscriptionInvoiceHistoryTable.ts